"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HAS_SEEN_TOOLBAR_NO_UNDO = exports.HAS_DISMISSED_TOOLBAR_NO_UNDO = void 0;
var HAS_DISMISSED_TOOLBAR_NO_UNDO = 'hasDismissedToolbarNoUndo';
exports.HAS_DISMISSED_TOOLBAR_NO_UNDO = HAS_DISMISSED_TOOLBAR_NO_UNDO;
var HAS_SEEN_TOOLBAR_NO_UNDO = 'hasSeenToolbarNoUndo';
exports.HAS_SEEN_TOOLBAR_NO_UNDO = HAS_SEEN_TOOLBAR_NO_UNDO;